import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "reactstrap";
import "./style.css";
import noavatar from "../../../assets/img/noavatar.png";
import { getData } from "../../../api/method";

const username = localStorage.getItem("username");

function CardCart() {
  const navigate = useNavigate();

  const [data, setData] = useState([]);

  const getCart = async () => {
    try {
      const result = await getData(`/api/Cart/user/${username}`);
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCart();
  }, [data]);

  return (
    <div>
      {data?.map((item) => (
        <div className="d-flex align-items-center" key={item.id}>
          <div className="cart_img_product border_product w-40">
            <img
              src={
                `${process.env.REACT_APP_URL_IMAGE + item.product.image}` ||
                noavatar
              }
              alt="product"
              width={50}
              height={50}
            />
          </div>

          <div className="ms-2 product_info">
            <p className="product_name">{item.product.name}</p>
            <p className="product_price fw-bold t-primary fs-15 pt-2 text-end">
              {(
                (item.product.price * (100 - item.product.discount)) /
                100
              ).toLocaleString("vi")}
              &#273;
            </p>
          </div>
        </div>
      ))}

      <div className="d-flex justify-content-end mt-4">
        <Button className="btn_view" onClick={() => navigate("/cart")}>
          View Cart
        </Button>
      </div>
    </div>
  );
}

export default CardCart;
